import { SceneSource, Resolution } from '../types/obs';
import { getSB } from '../lib/obs-engine';

interface CanvasPreviewProps {
  sources: SceneSource[];
  resolution: Resolution;
  isVertical: boolean;
}

export function CanvasPreview({ sources, resolution, isVertical }: CanvasPreviewProps) {
  const maxWidth = 600;
  const maxHeight = 400;
  const scale = Math.min(maxWidth / resolution.w, maxHeight / resolution.h, 1);
  const displayW = resolution.w * scale;
  const displayH = resolution.h * scale;

  return (
    <div className="canvas-stage">
      <div className={`canvas-frame ${isVertical ? 'v-frame' : ''}`}>
        <div className="obs-canvas" style={{ width: displayW, height: displayH, position: 'relative' }}>
          <div
            className="res-overlay"
            style={{
              background: isVertical ? 'rgba(244,63,94,.25)' : 'rgba(20,184,166,.25)',
              color: isVertical ? '#fda4af' : '#2dd4bf',
              borderColor: isVertical ? 'rgba(244,63,94,.3)' : 'rgba(20,184,166,.3)',
            }}
          >
            {resolution.w}×{resolution.h}
          </div>

          {sources.map((source) => {
            const blockClass = getSB(source.type);
            // positions/sizes are 0-1 percentages
            const left = source.position.x * displayW;
            const top = source.position.y * displayH;
            const width = source.size.w * displayW;
            const height = source.size.h * displayH;
            const border = source.border?.enabled ? source.border : null;
            const t = border ? border.thickness * scale : 0;

            return (
              <div key={source.id} style={{ opacity: source.visible ? 1 : 0.3 }}>
                {border && (
                  <div
                    style={{
                      position: 'absolute',
                      left: left - t,
                      top: top - t,
                      width: width + 2 * t,
                      height: height + 2 * t,
                      background: border.color,
                      borderRadius: 2,
                    }}
                  />
                )}
                <div
                  className={`src-blk ${blockClass}`}
                  style={{ left, top, width, height }}
                >
                  <div className="sb-lbl">{source.name}</div>
                  <div className="sb-pct">{Math.round(source.size.w * 100)}%</div>
                </div>
              </div>
            );
          })}

          {sources.length === 0 && (
            <div className="canvas-empty">
              <div style={{ fontSize: '24px', opacity: 0.3 }}>📐</div>
              <div style={{ fontSize: '11px' }}>Select a layout</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
